<template>
  <div
    v-if="ready"
    id="Admin">

    <section style="padding: 10px;font-size: 13px;">
      <section-title
        title="Overview"
        fontweight="bold"
        style="font-size: 24px;"/>
      <p>Shop Name: {{ shop.shop_name }}</p>
      <p>Business Form: {{ $t('business.form.' + shop.info.business.form_id) }}</p>
      <p>Business Type: {{ $t('business.type.' + shop.info.business.type_id) }}</p>
      <p>
        Installed:
        <span
          v-for="(permission, index) in shop.install_apps"
          :style="'margin: 0 5px 0 0;background:'+$t(getAppInfo(permission.app_id).translate + '.bgcolor')"
          class="badge badge-secondary">
          <i :class="$t(getAppInfo(permission.app_id).translate + '.icon')"/>
          {{ $t(getAppInfo(permission.app_id).translate + '.title') }}
        </span>
      </p>
      <p>Products: {{ shop.products.length }}</p>
      <p>POS Sessions: {{ shop.pos_sessions.length }}</p>
      <p>POS Transactions: {{ shop.pos_transactions.length }}</p>
      <p>PO: {{ shop.purchases.length }}</p>
      <p>SO: {{ shop.sales.length }}</p>
      <p>INV: {{ shop.invoices.length }}</p>
      <p>EXP: {{ shop.expenses.length }}</p>
      <p>PE: {{ shop.payments.length }}</p>
      <p>Customers: {{ shop.customers.length }}</p>
      <p>Vendors: {{ shop.vendors.length }}</p>
      <p>Warehouses: {{ shop.warehouses.length }}</p>
    </section>

    <hr >

    <section style="padding: 10px;font-size: 13px;">
      <section-title
        :title="'Products ' + shop.products.length"
        fontweight="bold"
        style="font-size: 24px;"/>
      <table
        class="dataTable table table-bordered"
        style="width: 100%">
        <thead>
          <tr>
            <th style="width: 50px;">{{ $t('message.image') }}</th>
            <th>{{ $t('message.category') }}</th>
            <th>{{ $t('message.modifier') }}</th>
            <th>{{ $t('message.discount') }}</th>
            <th>{{ $t('message.tax') }}</th>
            <th>{{ $t('message.barcode') }}</th>
            <th>{{ $t('message.sku') }}</th>
            <th>{{ $t('message.item') }}</th>
            <th>{{ $t('message.price') }}</th>
            <th>{{ $t('message.cost') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in shop.products"
            style="width: 50px;vertical-align: middle;">
            <td>
              <router-link
                v-if="item.type == 'product'"
                :to="{name: 'ProductEdit', query: {
                  'pid': item.product_id,
                  'pname': item.product_name
                }}"
                style="position: relative;top: -2px;">
                <img
                  :src="item.images.thumbnail || defaultImages.product"
                  width="68"
                  height="68">
              </router-link>
            </td>
            <td>
              <span
                v-if="item.category_name"
                class="badge badge-secondary">
                <i class="icon fas fa-sitemap"/>
                {{ item.category_name }}
              </span>
            </td>
            <td>
              <span
                v-for="(modifier, index) in item.modifiers"
                :key="modifier.modifier_id"
                class="badge badge-secondary"
                style="margin-right: 5px;">
                <i class="icon fas fa-project-diagram"/>
                {{ modifier.modifier_name }}
              </span>
            </td>
            <td>
              <span
                v-for="(discount, index) in item.discounts"
                :key="discount.modifier_id"
                class="badge badge-secondary"
                style="margin-right: 5px;">
                <i class="fas fa-tag"/>
                {{ discount.discount_name }}
                <template v-if="discount.type == 'percentage'">
                  ({{ discount.amount }}%)
                </template>
                <template v-if="discount.type == 'number'">
                  ({{ currency }} {{ discount.amount }})
                </template>
              </span>
            </td>
            <td>
              <span
                v-for="(tax, index) in item.taxes"
                :key="tax.modifier_id"
                class="badge badge-secondary"
                style="margin-right: 5px;">
                <i class="fas fa-dollar-sign"/>
                {{ tax.tax_name }}
                ({{ tax.amount }}%)
              </span>
            </td>
            <td>
              <div v-for="price in item.prices">
                <template>
                  <span v-if="price.barcode !== null">
                    <router-link
                      :to="{name: 'ProductEdit', query: {
                        'pid': item.product_id,
                        'pname': item.product_name
                    }}">
                      {{ price.barcode }}
                    </router-link>
                  </span>
                  <span v-else>-</span>
                </template>
              </div>
            </td>
            <td>
              <div v-for="price in item.prices">
                <template>
                  <span v-if="price.sku_code !== null">
                    <router-link
                      :to="{name: 'ProductEdit', query: {
                        'pid': item.product_id,
                        'pname': item.product_name
                    }}">
                      {{ price.sku_code }}
                    </router-link>
                  </span>
                  <template v-else>
                    <span v-if="isFoundCustomSkuCode(item.prices)">-</span>
                  </template>
                </template>
              </div>
            </td>
            <td>
              <div v-for="price in item.prices">
                <router-link
                  :to="{name: 'ProductEdit', query: {
                    'pid': item.product_id,
                    'pname': item.product_name
                }}">
                  {{ getProductFullName(item.product_name, price.attributes) }}
                </router-link>
                <span
                  v-if="!price.is_available"
                  class="badge badge-danger"
                  style="font-size: 9px;position: relative;top: -1px;">ไม่มีจำหน่าย</span>
              </div>
            </td>
            <td>
              <div v-for="price in item.prices">
                <template v-if="price.price !== null">
                  <span>
                    {{ getNumber(price.price) }}
                  </span>
                </template>
                <template v-else>
                  {{ $t('message.variable') }}
                </template>
              </div>
            </td>
            <td>
              <div v-for="price in item.prices">
                <template v-if="price.cost !== null">
                  {{ getNumber(price.cost) }}
                </template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <hr >

    <section style="padding: 10px;font-size: 13px;">
      <section-title
        :title="'Warehouses ' + shop.warehouses.length"
        fontweight="bold"
        style="font-size: 24px;"/>
      <table
        class="dataTable table table-bordered"
        style="width: 100%;">
        <thead>
          <tr>
            <th>Warehouse Name</th>
            <th>Short Name</th>
            <th>Address</th>
            <th>Created</th>
            <th>is_deleted</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(warehouse, index) in shop.warehouses">
            <td :class="[{'text-primary': warehouse.primary}]">
              {{ warehouse.warehouse_name }}
            </td>
            <td>
              {{ warehouse.short_name }}
            </td>
            <td>
              {{ warehouse.info.address }}
            </td>
            <td>
              {{ getDateTime(warehouse.created_at) }}
            </td>
            <td>
              {{ warehouse.is_deleted }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <hr>

    <section style="padding: 10px;font-size: 13px;">
      <section-title
        :title="'Stocks ' + stocks.length"
        fontweight="bold"
        style="font-size: 24px;"/>
      <table
        v-for="(stock, index) in stocks"
        class="dataTable table table-bordered"
        style="width: 100%;">
        <thead>
          <tr>
            <th>Product Name</th>
            <th>Min Stock</th>
            <th>Max Stock</th>
            <th>Bin Location</th>
            <th>In Stock</th>
            <th>Reserved</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in stock">
            <td>
              {{ getProductFullName(item.product.product_name, item.sku.attributes) }}
            </td>
            <td>
              {{ item.stock.control.minstock }}
            </td>
            <td>
              {{ item.stock.control.maxstock }}
            </td>
            <td>
              {{ item.stock.bin }}
            </td>
            <td>
              {{ item.stock.instock }}
            </td>
            <td>
              {{ item.stock.reserved }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <hr>

    <section style="padding: 10px;font-size: 13px;">
      <section-title
        :title="'POS Transactions ' + shop.pos_transactions.length"
        fontweight="bold"
        style="font-size: 24px;"/>
      <table
        class="dataTable table table-bordered"
        style="width: 100%;">
        <thead>
          <tr>
            <th class="text-center">{{ $t('message.date') }}</th>
            <th class="text-center">{{ $t('message.time') }}</th>
            <th class="text-center">{{ $t('apps.pos.message.ordernumbersort') }}</th>
            <th>{{ $t('message.productlist') }}</th>
            <th>{{ $t('message.customer') }}</th>
            <th class="text-center">{{ $t('message.cashier') }}</th>
            <th
              class="text-right"
              style="min-width: 100px;">{{ $t('message.totaldiscount') }}</th>
            <th
              class="text-right"
              style="min-width: 100px;">{{ $t('message.totaltax') }}</th>
            <th
              class="text-right"
              style="min-width: 100px;">{{ $t('message.totalcollected') }}</th>
            <th
              class="text-right"
              style="min-width: 100px;">{{ $t('message.totalrefund') }}</th>
            <th
              class="text-right"
              style="min-width: 100px;">{{ $t('message.nettotal') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(bill, index) in shop.pos_transactions"
            :id="'ref-'+bill.posbi_code">
            <td class="text-center">
              {{ getDate(bill.created_at) }}
            </td>
            <td class="text-center">
              {{ getDateCustom(bill.created_at, {format: 'H:mm'}) }}
            </td>
            <td class="text-center">
              {{ bill.posbi_code }}
            </td>
            <td>
              <item-list :orders="bill.orders" />
            </td>
            <td>
              <router-link-custom
                v-if="bill.customer"
                :to="{name: 'ContactCustomerEdit', query: {cus_id: bill.customer.customer_id, cus_name: bill.customer.customer_name}}"
                :text="bill.customer.customer_name"
                :to_appid="11"
                :current_appid="1"
                :disabled="bill.customer.is_deleted == true" />
            </td>
            <td class="text-center">
              {{ bill.user.email || bill.user.username }}
            </td>
            <td class="text-right">
              {{ getNumber(getBillTotalPrice(bill.orders, mixin).discount) }}
            </td>
            <td class="text-right">
              {{ getNumber(getBillTotalPrice(bill.orders, mixin).tax) }}
            </td>
            <td class="text-right">
              {{ getNumber(bill.total) }}
            </td>
            <td class="text-right">
              {{ getNumber(getTotalRefunds(bill.refunds)) }}
            </td>
            <td class="text-right">
              {{ getNumber(bill.total - getTotalRefunds(bill.refunds)) }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <hr>

    <section style="padding: 10px;font-size: 13px;">
      <section-title
        :title="'Customers ' + shop.customers.length"
        fontweight="bold"
        style="font-size: 24px;"/>
      <table
        class="dataTable table table-bordered"
        style="width: 100%;">
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Gender</th>
            <th>Birthdate</th>
            <th>address</th>
            <th>created</th>
            <th>is_deleted</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(customer, index) in shop.customers">
            <td>
              {{ customer.customer_name }}
            </td>
            <td>
              {{ customer.gender }}
            </td>
            <td>
              {{ customer.birthdate }}
            </td>
            <td>
              {{ customer.address }}
            </td>
            <td>
              {{ getDateTime(customer.created_at) }}
            </td>
            <td>
              {{ customer.is_deleted }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <hr>

    <section style="padding: 10px;font-size: 13px;">
      <section-title
        :title="'Vendors ' + shop.vendors.length"
        fontweight="bold"
        style="font-size: 24px;"/>
      <table
        class="dataTable table table-bordered"
        style="width: 100%;">
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Gender</th>
            <th>Birthdate</th>
            <th>address</th>
            <th>created</th>
            <th>is_deleted</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(vendor, index) in shop.vendors">
            <td>
              {{ vendor.vendor_name }}
            </td>
            <td>
              {{ vendor.gender }}
            </td>
            <td>
              {{ vendor.birthdate }}
            </td>
            <td>
              {{ vendor.address }}
            </td>
            <td>
              {{ getDateTime(vendor.created_at) }}
            </td>
            <td>
              {{ vendor.is_deleted }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <hr>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminUserAll',
  data () {
    return {
      ready: false,
      stocks: [],
    }
  },
  computed: {
    ...mapGetters({
      getAppInfo: 'getAppInfo',
      shop: 'getShop',
      defaultImages: 'getDefaultImages',
      getBillTotalPrice: 'getBillTotalPrice',
      currency: 'getCurrency',
    }),
  },
  watch: {
    ready: function (after) {
      if (after == true) {
        let that = this
        // dataTable option
        let option = this.dataTableOption()
        // set dataTable
        setTimeout(() => {
          that.dataTable = $('.dataTable').DataTable(option)
        }, 1)
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
  },
  beforeMount: function () {
    // set section
    this.$store.dispatch('setSection', 'admin')
  },
  created: async function () {
    await this.$store.dispatch('getShop', { shop_id: this.$route.query.shop_id })

    for (let i = 0; i < this.shop.warehouses.length; i++) {
      let r = await this.$store.dispatch('getStocks', this.shop.warehouses[i].warehouse_id)
      this.stocks.push(r.data)
    }

    // set ready
    this.ready = true
  },
  methods: {
    isFoundCustomSkuCode (prices) {
      var foundSku = false
      prices.map(price => {
        if (price.sku_code !== null) {
          foundSku = true
        }
      })
      return foundSku
    },
    getTotalRefunds (refunds) {
      var amount = 0
      refunds.map(refund => {
        amount += refund.amount
      })
      return amount
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/admin/ShopInfo.vue